export var ControlAnchor;
(function (ControlAnchor) {
    ControlAnchor[ControlAnchor["BMAP_ANCHOR_TOP_LEFT"] = 0] = "BMAP_ANCHOR_TOP_LEFT";
    ControlAnchor[ControlAnchor["BMAP_ANCHOR_TOP_RIGHT"] = 1] = "BMAP_ANCHOR_TOP_RIGHT";
    ControlAnchor[ControlAnchor["BMAP_ANCHOR_BOTTOM_LEFT"] = 2] = "BMAP_ANCHOR_BOTTOM_LEFT";
    ControlAnchor[ControlAnchor["BMAP_ANCHOR_BOTTOM_RIGHT"] = 3] = "BMAP_ANCHOR_BOTTOM_RIGHT";
})(ControlAnchor || (ControlAnchor = {}));



//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/node_modules/angular2-baidu-map/dist/enum/ControlAnchor.js
// module id = ../../../../angular2-baidu-map/dist/enum/ControlAnchor.js
// module chunks = common